<template>
    <div data-component="CartOffersCouponCodesTab"
         class="cart-offers-code-tab modl-tab-body">
        <div class="modl-body">
            <CartOffersCodeSearch :initial-selected-offers="selectedOffers"
                                  :initial-selected-offer-codes="selectedOfferCodes"
                                  :offers="offers"
                                  :allow-multiple="false"
                                  @update:selected-offer-codes="updateSelectedOfferCodes"
                                  @update:selected-offers="updateSelectedOffers"></CartOffersCodeSearch>
        </div>
    </div>
</template>

<script>
import CartOffersCodeSearch from '@/epos/vue/modals/CartOffers/CartOffersCodeSearch';
import { mapState } from 'vuex';

export default {
    name: 'CartOffersCouponCodesTab',

    components: {
        CartOffersCodeSearch,
    },

    props: {},

    data() {
        return {

            /**
             * An array of coupon offers that we have searched for.
             *
             * @type {Offer[]}
             */
            offers: [],

            /**
             * The key is the offerID.
             *
             * @type {Object<number, number>}
             */
            selectedOffers: {},

            /**
             * @type {Object<number, string>}
             */
            selectedOfferCodes: {},
        };
    },

    computed: {
        ...mapState('cartOffers', ['couponCodeOffers', 'selectedCouponCodeOffers', 'selectedCouponCodeOfferCodes']),
    },

    async created() {
        // Set up the data using the values fetched from the offersStore mapState.
        this.selectedOffers = this.selectedCouponCodeOffers;
        this.selectedOfferCodes = this.selectedCouponCodeOfferCodes;
        this.offers = this.couponCodeOffers;
    },

    methods: {
        updateSelectedOffers(newValue) {
            this.$store.commit('cartOffers/setSelectedCouponCodeOffers', newValue);
        },
        updateSelectedOfferCodes(newValue) {
            this.$store.commit('cartOffers/setSelectedCouponCodeOfferCodes', newValue);
        },
    },
};
</script>
